import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1319Model } from "../kymw1319.model";
import { KYMW1319InputVO } from "../vo/kymw1319-inputVO.model";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { Injectable } from "@angular/core";

/**
 * 企画商品特集商品情報更新
 * 
 * @export UpdatePlanGoodsFeatureService
 * @class UpdatePlanGoodsFeatureService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdatePlanGoodsFeatureService extends PlessJsonResponderSub<any> {
  model: KYMW1319Model;
  vo: KYMW1319InputVO;
  successFunc: Function;

  /**
   * bodyにセットする値を返す
   * 
   * @returns 
   * @memberof UpdatePlanGoodsFeatureService
   */
  getBody() {
    return new PlessRequest({
      update: {
        UpdatePlanGoodsFeature: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            PCode: this.vo.pcode,
            FeatureCode: this.model.selectedFeatureCode,
            StartOrderCode: this.model.startOrderCode,
            BundleCatalogFlag: this.vo.bundleCatalogFlag,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param vo 
   * @param successFunc 
   * @memberof UpdatePlanGoodsFeatureService
   */
  execute(model: KYMW1319Model, vo: KYMW1319InputVO, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updatePlanGoodsFeature', this.getBody())
  }

  /**
   * API通信成功時の処理
   * 
   * @param data 
   * @memberof UpdatePlanGoodsFeatureService
   */
  success(data: any): void {
    if (this.successFunc != null) {
      this.successFunc();
    }
  }
}